import React from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import MoneyIcon from '@mui/icons-material/AttachMoney';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import CastForEducationIcon from '@mui/icons-material/CastForEducation';
import UserIcon from '@mui/icons-material/PersonAddRounded';
import BarChartIcon from '@mui/icons-material/BarChart';
import BookIcon from '@mui/icons-material/Book';
import CategoryIcon from '@mui/icons-material/Category';
import {Link} from 'react-router-dom'
import PaidIcon from '@mui/icons-material/Paid';

const sidebarItems = [
    {
        name: 'Dashboard',
        Icon: DashboardIcon,
        path: '/dashboard'
    },
    {
        name: 'Categories',
        Icon: CategoryIcon,
        path: '/categories'
    },
    {
        name: 'Users',
        Icon: SupervisedUserCircleIcon,
        path: '/users'
    },
    {
        name: 'Sellers',    
        Icon: CastForEducationIcon,
        path: '/sellers'
    },
    {
        name: 'Courses',
        Icon: BookIcon,
        path: '/courses'
    },
    {
        name: 'Enrollments',
        Icon: UserIcon,
        path: '/enrollments'
    },
    {
        name: 'Hulluware Finance',
        Icon: MoneyIcon,
        path: '/finance'
    },
    {
        name: 'Withdrawals',
        Icon: PaidIcon,
        path: '/withdrawals'
    },
    // {
    //     name: 'Analytics',
    //     Icon: BarChartIcon,
    //     path: '/analystics'
    // },
]

export default function Sidebar() {
  return (
    <div className='flex flex-col gap-5 bg-white w-[250px] h-full p-4'>
        {sidebarItems.map(item => (
            <Link to={item.path} className='flex items-center justify-between'>
                <div className='flex items-center gap-2'>
                    {<item.Icon style={{color: '#000000b5', fontSize: 20}}>Filled</item.Icon>}
                    <p className='text-[15px] text-[#000000b5]' href='/'>{item.name}</p>
                </div>
                <ArrowForwardIosIcon style={{color: '#000000b5', fontSize: 16}}>Filled</ArrowForwardIosIcon>
            </Link>
        ))}
    </div>
  )
}
